import axios from '@/libs/api.request'

export const getFormulaList = ({ kw, page, perPage }) => {
  const data = {
    kw,
    page,
    perPage
  }
  return axios.request({
    url: 'formula/list',
    data,
    method: 'post'
  })
}

export const getFormula = (id) => {
  return axios.request({
    url: 'formula/' + id,
    method: 'get'
  })
}

export const addFormula = (customerId, name, code, weight, color, pkg, pkgSpec, pdTime, note) => {
  const data = {
    'customer_id': customerId,
    name,
    code,
    weight,
    color,
    pkg,
    'pkg_spec': pkgSpec,
    'pd_time': pdTime,
    note
  }
  return axios.request({
    url: 'formula/add',
    data,
    method: 'post'
  })
}

export const deleteFormula = (id) => {
  return axios.request({
    url: 'formula/' + id,
    method: 'delete'
  })
}

export const modifyFormula = (id, customerId, name, code, weight, color, pkg, pkgSpec, pdTime, note) => {
  let data = {
    'customer_id': customerId,
    name,
    code,
    weight,
    color,
    pkg,
    'pkg_spec': pkgSpec,
    'pd_time': pdTime,
    note
  }
  return axios.request({
    url: 'formula/' + id,
    data,
    method: 'post'
  })
}
